import { Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { SnackbarContext } from "../../../../contexts/Snackbar";
import { deleteTherapy } from "../../../../enums/queryFunction/Delete";
import useConfirm from "../../../../hooks/useConfirm";
import { SINGLE_BOX_KEY } from "../../../../enums/QueryKeys";

export default function DeleteTherapy() {
  const queryClient = useQueryClient();
  const { id } = useParams();
  const navigate = useNavigate();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const { t } = useTranslation();
  const { ConfirmationDialog, confirm, getMessage } = useConfirm(
    t("AreYouSure"),
    t("Accept"),
    t("Cancel"),
    "warning"
  );

  async function handleDeleteTherapy() {
    getMessage(t("DeleteTherapyConfirmation"));
    const ans = await confirm();
    if (ans) {
      mutate(id);
    }
  }

  const { mutate } = useMutation({
    mutationFn: deleteTherapy,
    onSuccess: () => {
      queryClient.invalidateQueries([SINGLE_BOX_KEY]);
      navigate(-1);
    },

    onError: (error) => {
      handleSnackbar("errorMessage", "error");
    },
  });

  return (
    <Fragment>
      <IconButton
        color="error"
        title={t("DeleteTherapy")}
        onClick={() => handleDeleteTherapy()}
      >
        <Delete />
      </IconButton>
      <ConfirmationDialog />
    </Fragment>
  );
}
